<div id="username-remediation-page" class="flex justify-center items-center">

  <div class="flex flex-col items-center justify-center gap-10 public-container" role="main">
    @if (notification !== undefined) {
      <div role="complementary" class="w-full" aria-label="username-remediation-notification">
        @switch (notification) {
          @case (notificationEnum.TryAgainLater) {
            <pin-notification type="alert">
              This page is currently unavailable. Please try again later.
            </pin-notification>
          }
        }
      </div>
    }

    <div class="login-content w-full">
      <form [formGroup]="remediationForm" (ngSubmit)="confirmUsername()" class="flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <h1 class="dcp-h1">Update Your Username</h1>

          <p class="dcp-body">
            To support recent DCP security enhancements, you must update your username to proceed.
          </p>
        </div>

        <div class="flex flex-col gap-4">
          <mat-form-field appearance="outline">
            <mat-label>New username</mat-label>
            <input matInput placeholder="Username" formControlName="username" maxlength="128">

            @if (remediationForm.controls.username.hasError('required')) {
              <mat-error>Username is <strong>required</strong></mat-error>
            }
            @if (remediationForm.controls.username.hasError('nonAsciiPrintable')) {
              <mat-error>Username cannot contain invalid characters.</mat-error>
            }
            @if (remediationForm.controls.username.hasError('taken')) {
              <mat-error>This username is already in use. Please choose a different one.</mat-error>
            }
          </mat-form-field>

          <div class="flex flex-col items-center justify-center gap-4 w-full">
            <pin-button buttonId="confirm-username-button" buttonStyle="filled" class="w-full"
                        [isDisabled]="isLoading">Update Username</pin-button>
            <pin-button [buttonType]="buttonType.DEFAULT" buttonStyle="icon-link" iconName="arrow_back" buttonType="button"
                        (buttonClick)="backToLogin()">
              Back to login
            </pin-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

@if (isLoading) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

